import React from 'react';
import FieldGenerico from '../componentes_generales/componentes_formulario/fields/fieldgenerico';
import FieldSelect from '../componentes_generales/componentes_formulario/fields/fieldselect/fieldselect';
import FieldGetSelectAsync from '../componentes_generales/componentes_formulario/fields/fieldselect/fieldgetselectasync';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { Field, reduxForm , formValueSelector  } from 'redux-form';
import FieldBusqEspecifica from '../componentes_generales/componentes_formulario/fields/busqueda_especifica/fieldselectasync-busq-especif';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { get_FechaLocalActual } from '../../funciones_globales/utils.js';
import { cargarCatalogos, cargarCatalogosGenerico, cargarCatalogosGenericoAsyncInvertido, cargarCatalogosGenericoAsync, cargarCatalogos_Otros, cargarCatalogosBodegaFacturacion} from '../../funciones_globales/catalogos';
import { cargar_Importacion, cargar_ValoresIniciales } from '../../actions/importaciones/act_impor02';
import styled from 'styled-components';
import FieldDate from '../componentes_generales/componentes_formulario/fields/fielddate/fielddate';
import { completar_String, formatearLabel, desformatearFecha } from '../../funciones_globales/format';
import { connect } from 'react-redux';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import global_axios from '../../funciones_globales/interaccionapi';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm  } from '../../actions/generales/act_gen03';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import { visualizarReporteEnPdf, generarReporteEnExcel } from '../../funciones_globales/interaccionApiReportes';
import { cargarPermisoBoton } from '../../funciones_globales/accionesPorUsuario';
import { validarPermisoAcceso, validarFechaTransaccionSeleccionada } from '../../funciones_globales/utils';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

const ContenedorBotonAdd = styled.div`
    padding-top: 20px;
    @media (max-width: 991px) {
    padding: 0px;
    }
`;

const BotonAdd = styled.button`
    margin-top: 10px;
    width: 100%;
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: -1;
`;

const ContenedorModal = styled.div`  
    margin-top: 20px;
    height: 100%;
    width: 100%;
`;

const ContenedorModalCompra = styled.div`  
    margin-top: 20px;
    height: 100%;
    width: 600px;
`;

const Radio = styled.input`
    font-weight: 600;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

const LabelSub = styled.label`
    font-weight: 400;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

const validate = values => {
    const errors = {}
    if(!values.factura_p && values.lote_import){//
      errors.factura_p = 'El campo es obligatorio';
    }
    if(!values.lote_import && values.factura_p){//
        errors.lote_import = 'El campo es obligatorio';
    }
    if(!values.fec_confirmacion){
        errors.fec_confirmacion = 'El campo es obligatorio';
    }
    if(!values.fec_embarque){
        errors.fec_embarque = 'El campo es obligatorio';
    }
    if(!values.fec_llegada_aduana){
        errors.fec_llegada_aduana = 'El campo es obligatorio';
    }
    if(!values.fec_recepcion_ofi){
        errors.fec_recepcion_ofi = 'El campo es obligatorio';
    }    
}

class FormImport02 extends React.Component{
    constructor(props){
        super(props);
            this.state = {
                secuencia_compra: "",
                esEditable:false,
                lbl_fecha_seleccionada: "",
                isOpen: false, //modal
                controllFillRecibido: false,             
                codigo_importacion: '',
                arancel_temp: 0,
                proveedor: [],
                forma_pago: [],
                totalFOB: null,
                data_importacion: [],
                operacion: 'M', 
                permiso: null,
                fechaProceso: null,
                //Select
                optFechasPago: [],                

                //FormaPago
                modFormaPago: null,
                //revisarMetodosPago: false,

                //STATES PARA BOTONES POR USUARIO
                liquidacionButton: null,

                //CantidadAranceles para reporte
                cantidadArancel:0,

                columnDefs_modal:  [   
                                        {   header: "",
                                            field: "eliminar",
                                            width: 60,
                                            type: "link_elim"                                                
                                        },
                                        {   header: "Sec",
                                            field: "secuencia",
                                            width: 30,
                                            type: "string"
                                        },
                                        {   header: "Tipo",
                                            field: "tipo_fec",
                                            width: 30,
                                            type: "num_entero"
                                        },                                      
                                        {   header: "Descripción",
                                            field: "descripcion",
                                            width: 150,
                                            type: "string"                       
                                        },
                                        {   header: "Fecha",
                                            field: "fecha",
                                            width: 65,
                                            type: "fecha"                       
                                        },
                                        {   header: "Dias plazo",
                                            field: "dias_plazo",
                                            width: 65,
                                            type: "num_entero"                                             
                                        },
                                        {   header: "Porcentaje",
                                            field: "porcentaje",
                                            width: 65,
                                            type: "num_entero"                                             
                                        },                                
                                        {   header: "Fecha pago",
                                            field: "fecha_pago",
                                            width: 65,
                                            type: "fecha"                                             
                                        },
                                        {   header: "Valor a pagar",
                                            field: "valorcalculado",
                                            width: 75,
                                            type: "num_decimal",
                                            editable: false                                                     
                                        },
                                        {   header: "Saldo",
                                            field: "saldo",
                                            width: 75,
                                            type: "num_decimal"                                                
                                        }                                       
                                    ],
                data_modal_forma_pg: [],

                gridOptionsModal: {
                    context: {
                        componentParent: this
                    },
                    onCellValueChanged: (event)=>{
                        console.log('refresh de saldo en grid', event.data)
                       if(event.data.poseePagos){
                           if(parseFloat(event.newValue)>=parseFloat(event.data.valorAbono)) {
                            //event.data.valorcalculado=event.oldValue;
                            event.data.saldo=event.newValue;
                           }else{
                             alert("No puede ingresar el valor debido a que posee abonos")
                           }
                           
                       }else{
                           event.data.saldo=event.newValue;
                       }
                       this.apiPago.refreshCells(); 
                    }  
                    
                },   
                
                gridOptions: {
                    context: {
                        componentParent: this
                    },
                    enableCellChangeFlash: true,
                    enableFilter: true,
                    enableSorting: true,
                    onCellValueChanged: (event)=>{ 
                        this.calcularColSubtotal(event.data);
                        let newFob = this.sumarValorFob();
                        this.props.change('fob_r', newFob);
                        this.props.change('FOBArancel', newFob);
                        this.api.refreshCells(); 
                    }  
                },           
                columnDefs: [   
                                {   header: "",
                                    field: "eliminar",
                                    width: 75,
                                    type: "link_elim"                                                
                                },
                                {   header: "Sec",
                                    field: "secuencial",
                                    width: 55,
                                    type: "string"
                                },
                                {   header: "Código",
                                    field: "articulo",
                                    width: 70,
                                    type: "string",                                    
                                },
                                {   header: "Descripción",
                                    field: "nombre",
                                    width: 260,
                                    type: "string"                       
                                },
                                {   header: "Cant.",
                                    field: "cantidad",
                                    width: 70,
                                    type: "num_entero_edit",
                                    editable: true                                               
                                },
                                {   header: "Recibido",
                                    field: "recibido",
                                    width: 80,
                                    type: "num_entero_edit",
                                    editable: false                                            
                                },                                
                                {   header: "P. FOB",
                                    field: "precio_fob",
                                    width: 70,
                                    type: "num_decimal_edit",
                                    editable: true,
                                    valueFormatter: this.formatearNumero                                              
                                },
                                {   header: "Subtotal",
                                    field: "subtotal",
                                    width: 75,
                                    type: "num_decimal"                                                
                                },                                
                                {   header: "Arancel",
                                    field: "arancel",
                                    width: 75,
                                    type: "num_entero_edit"                                                
                                },
                                {   header: "Descuento",
                                    field: "descuento",
                                    width: 90,
                                    type: "num_decimal"                                                
                                },
                                {   header: "Factor CT",
                                    field: "factor",
                                    width: 85,
                                    type: "string"                                                
                                },
                                {   header: "Costo Total",
                                    field: "costo_cif",
                                    width: 90,
                                    type: "num_decimal"                                                
                                },
                                {   header: "B. Fob",
                                    field: "v_fob",
                                    width: 85,
                                    type: "num_decimal"                                                
                                },
                                {   header: "Salvaguarda",
                                    field: "salvaguarda",
                                    width: 100,
                                    type: "num_decimal"                                                
                                }
                            ],

                CIF:true,
                isOpenCompra: false,
                isOpenDetImp: false,
                bodega: [],
                tipoCT: [],
                flete: [],

                //Aux
                valorFobOriginal: 0,
                fechaConfimacionOrg: null,
                fechaEmbarqueOrg: null,
                
                //ModalDetImportacion
                opcionesPrint: 'P', //P => PDF || E => Excel
            };

            this.anularCompra = this.anularCompra.bind(this);
            this.onGridReady = this.onGridReady.bind(this);
            this.onGridReadyPago = this.onGridReadyPago.bind(this);
            this.inicializarComponentes = this.inicializarComponentes.bind(this);
            this.imprimir = this.imprimir.bind(this);
            this.impLiqImportacion = this.impLiqImportacion.bind(this);
            this.impLiqImportacionB = this.impLiqImportacionB.bind(this);
            this.impCompraImp = this.impCompraImp.bind(this);
            this.addArticulo = this.addArticulo.bind(this);
            this.anularImportacion = this.anularImportacion.bind(this);

            this.getImportacion = this.getImportacion.bind(this);
            this.toggleModalDetImp = this.toggleModalDetImp.bind(this);
            this.actualizarCamposCheque = this.actualizarCamposCheque.bind(this);
            this.insertArticulo = this.insertArticulo.bind(this);

            this.actualizarMetodosPago = this.actualizarMetodosPago.bind(this);
            
            //this.activadorVerificadorFechaPorPago = this.activadorVerificadorFechaPorPago.bind(this);
        }
    
    //Operaciones
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject('Compra no existe o esta anulada...');
            });
        });
    }

    actualizarCamposCheque(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({
          [name]: value
        });
    }

    //Formater
    formatearNumero(params){
        return parseFloat(params.value).toFixed(5).toString().replace(/(\d)(?=(\d{6})+(?!\d))/g, "$1,");
    }

//================ MODAL COMPRA OPS ===============
    toggleModalCompra = () => {
        this.setState({
            isOpenCompra: !this.state.isOpenCompra
        });
    }

    anularCompra(){
        if(this.props.compra!==undefined){
            var proceder = true;
            var data={};
            data.Localidad = '01';
            data.Importacion = this.state.codigo_importacion;
            data.IdRegAudit = this.props.IdRegAudit;
           
            
            
            this.cargarObjetos('/compras?compra='+this.props.compra).then((result)=>{
                if(result!==null){
                    if(result[0].EnTransito!=='S'){
                        proceder = false
                        alert("La compra #: "+this.props.compra+" no se encuentra en transito, imposible anular")
                    }
                }

                if(proceder===true){
                    var mensaje = window.confirm("Esta apunto de anular la compra #: "+this.props.compra+", ¿continuar?");
                    if(mensaje){
                        let config_request = {
                            method: 'PATCH',
                            url: '/compras/'+this.props.compra+'/importacion',
                            data
                        }
                        global_axios(config_request)
                        .then((response)=>{
                            
                            alert(response.data.msg)
                            this.inicializarComponentes()         
                        }) 
                        .catch(function(error){           
                            if (error.response){
                                alert(error.response.data.msg);
                            }
                        })
                    }
                }
            })
        }else{
            alert("Cargue una Importación")
        }
    }

    saveCompra(){
        var transaccion = true;
        let fechaProceso = getFechaProcesoPorModulo('01');

        if(this.state.codigo_importacion!==""){
            var data={};

            data.localidad = '01';
            data.proveedor = this.props.Proveedor;
            data.tipo = 'E';
            data.dui = ((this.props.DUI==="" || this.props.DUI === undefined)? '': this.props.DUI)
            data.factura = this.props.factura;
            data.importacion = this.state.codigo_importacion;
            data.formaPago = this.props.FormaPago;
            data.totalConIva = this.props.TotalCosto;
            data.totalSinIva = 0;
            data.porcentajeIva = 0;
            data.importe = this.props.TotalCosto;
            data.saldo = this.props.TotalCosto;
            data.tipoDescuento = 'P';
            data.descuento = 0.00;
            data.valorDescuento = 0.00;
            data.tipoFlete='P';
            data.flete = 0.00;
            data.valorFlete = 0.00;
            data.usuario = getItemDatosSesion('usuario').toString();
            data.status = 'E';
            data.tipoPago = 'I'

            var tipoCT = this.props.tipoCT
            data.creditoTributario = tipoCT==='02'?tipoCT:tipoCT.value;

           
            var bodega = this.props.bodega
            //Willy 2019-11-29 -> permitir seleccionar bodega ->disabled false en select bodega
            if(bodega==='01'){
                data.bodega=bodega;
            }else{
                if(typeof bodega ==="string"){
                    data.bodega=bodega;
                }else{
                    data.bodega=bodega.value;
                }
            }
            console.log(  data.bodega)
            data.refrendo = 'P';

            data.fecha =  formatearFechaMoment_a_String(this.state.fechaProceso);
            data.fechaVencimiento = formatearFechaMoment_a_String(this.state.fechaProceso);
            
            //Detalle Importacion
            //data.DetalleImportacion = this.props.detalle_importacion;

            //Limpieza de JSON DET IMPORTACION.
            let arrayDet = [];
            this.props.detalle_importacion.forEach((DET)=>{
                let item = {};

                item.secuencial = DET.secuencial;
                item.articulo = DET.articulo;
                item.recibido = parseInt(DET.recibido, 10);
                item.costo_cif = DET.costo_cif;
                item.precio_fob = DET.precio_fob;

                arrayDet.push(item);
            })

            data.DetalleImportacion = arrayDet;
            
            // Validacion de fecha de proceso que se puede cambiar ------------------------------
            if (this.props.permiteCambioFProceso==='S'){
                let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProceso, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
                if(resultadoValidFProceso.esValida===false){
                    transaccion = false;
                    alert(resultadoValidFProceso.msg);
                }
            }
            
            if(transaccion===true){
                let config_request = {
                    method: 'POST',
                    url: '/compras/importacion',
                    data
                }
    
                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then((response)=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    alert(response.data.msg)
                    this.inicializarComponentes()         
                }) 
                .catch((error)=>{           
                    this.props.cambiar_VisualizacionLoading(false);
    
                    if (error.response){
                    alert(error.response.data.msg);
                    }
                })
            }
        }else{
            alert("Cargue una importación")
        }
    }

//=================================================


//================ MODAL FormaPago OPS ===============
    toggleModal = () => {
        if(this.state.modFormaPago===null){
            this.setState({
                isOpen: !this.state.isOpen
            });
            //Limpiar parametros de la fecha al salir
            this.props.change("select_fecha", '')
            this.props.change("fec_seleccionada", '')
            this.props.change("cant_dias", '')
            this.props.change("porcentaje_pg", '')
            this.actualizarMetodosPago();
        }else{
            alert("Tiene cambios pendientes, grabe antes de salir")
        }
    }

    saveFormaPago(){
        console.log("SAVE FORMA DE PAGO")
        console.log("valor control_valor_pagar")
        console.log(this.control_valor_pagar(this.state.data_modal_forma_pg))
        console.log("Valor 1")
        console.log(this.control_valor_pagar(this.state.data_modal_forma_pg))
        console.log("Valor 2")
        console.log(this.props.fob_r)
        console.log(this.control_valor_pagar(this.state.data_modal_forma_pg).toFixed(2)===parseFloat(this.props.fob_r).toFixed(2))
        var acc=0;
        acc = (this.control_porcentaje_pago(this.state.data_modal_forma_pg))
        if(this.state.estado_import !== 'C'){
            if(acc<100){
                alert("El porcentaje de pago es inferior al 100%");
            }else if(acc===100){
                //Se añade la validacion que el valor pagar no debe superar el valor de F.O.B
                if(this.control_valor_pagar(this.state.data_modal_forma_pg).toFixed(2)===parseFloat(this.props.fob_r).toFixed(2)){
                    let arrayEnvio = [];
                    this.state.data_modal_forma_pg.forEach((det_pg)=>{
                        var item = {};
        
                        item.secuencia = this.props.detalle_forma_pago.length -1;
                        item.tipo_fec = det_pg.tipo_fec
                        item.descripcion = det_pg.descripcion
                        item.fecha = det_pg.fecha
                        item.dias_plazo = det_pg.dias_plazo
                        item.porcentaje = parseInt(det_pg.porcentaje,10)
                        item.fecha_pago = det_pg.fecha_pago
                        item.fob_base = det_pg.fob_base
                        item.valorcalculado = det_pg.valorcalculado
                        item.estado = 'A'
        
                        arrayEnvio.push(item);
                    })
        
                    let config_request = {
                        method: 'PUT',
                        url: '/importaciones/' + this.state.codigo_importacion.toString()+ '/pagosimportacion' ,
                        data: arrayEnvio
                    };
                                
                    global_axios(config_request)
                    .then((response)=>{
                        alert('La forma de pago se registró correctamente.');   
                        this.setState({modFormaPago: null, 
                            //revisarMetodosPago: false, 
                            isOpen:false,
                            
                            //Seteo de nuevos valor Originales al haber grabado
                            fechaConfimacionOrg: this.props.fec_confirmacion,
                            fechaEmbarqueOrg: this.props.fec_embarque,
                            valorFobOriginal: this.sumarValorFob(),
                        })     
                    }) 
                    .catch(function(error){                
                        if (error.response){
                        alert(error.response.data.msg);
                        }
                    })
                }else{
                    alert("El valor total a pagar es diferente al del F.O.B")
                }
                
            }else{
                alert("El porcentaje de pago es superior al 100%");
            }
        }else{
            alert("No se puede modificar importaciones con compra asignadas");
        }

                 
    }
//====================================================
    toggleModalDetImp(){
        this.setState({
            isOpenDetImp: !this.state.isOpenDetImp
        });
    }

    submit(e){
        let fechaProceso = getFechaProcesoPorModulo('01');

        if(this.state.codigo_importacion!==""){
            var transaccion = true;
            var mensaje = window.confirm("¿Desea modificar importación?");

            if (mensaje){
                var acc=0;
                var ArrayFormaPago = [];
                ArrayFormaPago = this.state.data_modal_forma_pg
                ArrayFormaPago.forEach((det)=>{
                    if(det.estado==='A'){
                        acc = acc + parseInt(det.porcentaje,10)
                    }
                })

                //Rtoala 2021-08-11 quitar validacion forma pago
                //if(this.controlCambiosFechasImportacion() === true && this.state.estado_import !== 'C'){
                 //   alert("Existen cambios realizados en la fechas, volver a grabar los metodos de pago");
                  //  transaccion = false
                //}


                if(this.props.estado_import!=='P' && (this.props.compra==="" || this.props.compra===null) ){
                    alert("Esta importacion no tiene estado pendiente, informe a Sistemas");
                    transaccion = false                    
                }
                
                if(this.props.estado_import==='C' ){
                    alert("Importacion con una compra generada, no se puede modificar");
                    transaccion = false                    
                }

                //Validación de permisos
                let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
                if(operacion.esValido===false){
                    transaccion = false;
                    alert(`- ${operacion.msg}\n`)
                }

                if(acc===100){
                    var totalRecibidos
                    e.detalle_import.forEach((det)=>{ 
                        totalRecibidos =  totalRecibidos + det.recibido 
                    })
                    if(totalRecibidos > 0 && e.factura_p===""){
                        alert("No pueden existir items recibidos sin factura");
                        transaccion = false;
                    }

                    //validacion factura
                    if((e.factura_p==="" && e.lote_import ==="") || (e.lote_import==="" && e.factura_p!=="") || (e.lote_import!=="" && e.factura_p==="") ){
                        transaccion = false;
                        alert("Debe llenar un lote si ingreso una factura o viceversa");
                    }

                    // Validacion de fecha de proceso que se puede cambiar ------------------------------
                    if (this.props.permiteCambioFProceso==='S'){
                        let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProceso, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
                        if(resultadoValidFProceso.esValida===false){
                            transaccion = false;
                            alert(resultadoValidFProceso.msg);
                        }
                    }
                    
                    if(transaccion===true){
                        e.importacion = this.state.codigo_importacion;
                        e.accion = 'M';
                        e.localidad = '01';
                        e.usuario = getItemDatosSesion('usuario').toString();
                        e.f_anulada = null;
                        e.fecha_proceso = formatearFechaMoment_a_String(this.state.fechaProceso);
                        //ADDED 2018-07-10 Control de data null
                        e.dai_num = e.dai_num===null?'':e.dai_num;
                        e.poliza = e.poliza===null?'':e.poliza;
                        e.compra = e.compra===null?'':e.compra;

                        if(this.props.factura!==""){
                            e.fec_contable = get_FechaLocalActual();
                        }else{
                            e.fec_contable = "";
                        }

                        //Limpieza de JSON DET IMPORTACION.
                        let arrayDet = []
                        this.state.data_importacion.forEach((DET)=>{
                            let item = {};                            

                            item.articulo = DET.articulo;
                            item.cantidad = parseInt(DET.cantidad, 10);
                            item.recibido = parseInt(DET.recibido, 10);
                            item.precio_fob = DET.precio_fob;
                            item.costo_cif = DET.costo_cif;
                            item.flete = DET.flete;
                            item.arancel = DET.arancel;
                            item.factor = DET.factor;
                            item.descuento = DET.descuento;

                            arrayDet.push(item);                       
                        })

                        e.detalle_import = arrayDet;

                        let config_request = {
                            method: 'PATCH',
                            url: '/importaciones/' + this.state.codigo_importacion.toString(),
                            data: e
                        }

                        this.props.cambiar_VisualizacionLoading(true);
                        global_axios(config_request)
                        .then((response)=>{
                            this.props.cambiar_VisualizacionLoading(false);
                            
                            Promise.all([        
                                this.props.cargar_ValoresIniciales(),
                                this.setState({operacion: 'G', data_importacion: [], modFormaPago: null, 
                                //revisarMetodosPago: false
                                })                                
                            ])
                            .then(()=>{
                                
                                alert('La importación se registró correctamente.');
                                
                                //Proceso de carga de importacion
                                let imp = {}
                                imp.value = this.state.codigo_importacion;
                                imp.label = this.state.codigo_importacion;

                                this.props.change('importacion', imp)
                                this.getImportacion();
                            })
                            .catch((error)=>{    
                                this.props.cambiar_VisualizacionLoading(false);                        
                                if (error.response){
                                alert(error.response.data.msg);
                                }
                            })
                        }) 
                        .catch((error)=>{    
                            this.props.cambiar_VisualizacionLoading(false);                        
                            if (error.response){
                            alert(error.response.data.msg);
                            }
                        })
                    }
                }else{
                    alert("Revisar formas de pago");
                }
            }
        }else{
            alert("Cargue una importación");
        }
    }

    onGridReady(params) {
        this.api = params.api;
        this.columnApi = params.columnApi;
    }
    onGridReadyPago(params) {
        this.apiPago = params.api;
        this.columnApiPago = params.columnApi;
    }
    
    actualizarCabeceraGrid(){
        //Validacion columnas editables
        console.log("CHANGER STATER")
        console.log(this.props.compra)
        console.log(this.props.factura)
        if((this.props.compra === "" || this.props.compra === undefined) && (this.props.factura === "" || this.props.factura === undefined)){
            console.log("SIN COMPRA - SIN FACTURA")
            this.changeStateHeader('recibido', false);
            this.changeStateHeader('precio_fob', true);
            this.changeStateHeader('cantidad', true);
            this.changeStateHeader('arancel', true);
        }else if(this.props.compra !== "" && (this.props.factura === "" || this.props.factura === undefined) ){
            console.log("COMPRA - SIN FACTURA")
            this.changeStateHeader('recibido', false);
            this.changeStateHeader('precio_fob', true);//this.changeStateHeader('precio_fob', false);
            this.changeStateHeader('cantidad', false);
            this.changeStateHeader('arancel', false);
             
        }else if(this.props.factura !== "" && (this.props.compra === "" || this.props.compra === undefined)){
            console.log("COMPRA - FACTURA")
            this.changeStateHeader('recibido', true);
            this.changeStateHeader('precio_fob', true);//this.changeStateHeader('precio_fob', false);
            this.changeStateHeader('cantidad', false);
            this.changeStateHeader('arancel', false); 
        }
    }
    
    changeStateHeader(col_field, value){

        var col = this.columnApi.getColumn(col_field);
        var colDef = col.getColDef();
        colDef.editable = value;
        this.api.refreshHeader();
    }

    cargarSecuenciaCompra(){

        let config_request = {
            method: 'GET',
            url: '/secuenciales/Compra',
          };
 
        return new Promise((resolve, reject)=>{
            global_axios(config_request)
            .then((response)=>{
                resolve(response.data.map(item => (item.codigo) ));
            })
            .catch((err)=>{
                console.log('Error al cargar datos de parámetros desde API: ' + err);
            });
        })
    }
    
    componentDidMount(){
        Promise.all([
            cargarCatalogos('FORMAPAGO'),cargarCatalogosGenerico('/proveedores?tipo=proveedor'),
            cargarCatalogosBodegaFacturacion('Bodega'),cargarCatalogos('CTRIBUTAR'),cargarCatalogos_Otros('IMP-FECHAS'),
            this.props.generar_LogAuditoriaIngresoForm('0302')
        ])
        .then(([result_formaPago, result_proveedores, result_bodega, result_tipoCT, result_fechas ]) => {
            //Asignacion de Fecha
            let fechaProceso = getFechaProcesoPorModulo('03');

            this.setState(
                { forma_pago: result_formaPago, proveedor: result_proveedores, bodega: result_bodega,
                    tipoCT: result_tipoCT, optFechasPago: result_fechas, permiso: this.props.permiso,
                    fechaProceso: moment(fechaProceso, 'DD/MM/YYYY')
            })
            //CODIGO: 010101 --> BOTON LIQUIDACION
            cargarPermisoBoton('010101',this.props.Usuario).then((resultado)=>{
                this.setState({liquidacionButton: resultado})
            }); 
        })
        .catch(err => {
            console.log(err);
        });        
        this.props.cargar_ValoresIniciales();
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0302');
    }

    setFormaPago(){
        if(this.props.tipo_fecha !== null && this.props.tipo_fecha !==undefined){
            var selFecha = this.props.tipo_fecha.value
            if(selFecha==="1"){
                this.setState({lbl_fecha_seleccionada: this.props.fec_confirmacion}, ()=>{
                    this.props.change("fec_seleccionada", this.state.lbl_fecha_seleccionada)
                })
            }else if(selFecha==="2"){               
                this.setState({lbl_fecha_seleccionada: this.props.fec_embarque}, ()=>{
                    this.props.change("fec_seleccionada", this.state.lbl_fecha_seleccionada)
                })
            }else{
                alert("Tipo de fecha fuera de rango [1 o 2]")
                this.props.change("select_fecha", 1)
            }
        }
    }

    verificacionActualizarCabeceras(){
        console.log("ON BLUR ACTIVATED", this.props.factura)
        if (this.props.factura){
            console.log("CHANGE GRID", this.props.factura)
            this.actualizarCabeceraGrid();
            this.setAllRecibido(this.state.data_importacion);
        }
    }

    //PROCESO PARA ACTUALIZACION DE RECIBIDO
    setAllRecibido(data_array){

        data_array.forEach((det)=>{
            if(det.recibido === 0)
            det.recibido = det.cantidad;
        });
        this.setState({ data_importacion: data_array },()=>{
            this.api.refreshCells();
        })
    }

    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }

    getImportacion(){

        //Asignacion de CIF => true para activar opcion compra
        this.setState({CIF: true})
        
        if (!this.props.codigo_importacion){
            alert('Ud. no ha seleccionado una importación que desee editar.');
        }else{ 
            
            const codigo_import_editar = this.props.codigo_importacion.value;
            this.props.cargar_ValoresIniciales();   
            this.props.cargar_Importacion_a_Editar(codigo_import_editar).then((result)=>{

                
                if(this.props.lote_import === "" || this.props.lote_import===null){
                    this.props.change('lote_import', undefined)
                }

               
                this.setState({ cantidadArancel: this.props.cantidadArancel })
                

                var total_salvaguarda = 0;
                this.props.detalle_importacion.forEach((det)=> {
                    console.log(det.art.DescuentoArancel)
                    det.nombre = det.art.nombre;
                    det.descuento = (det.art.DescuentoArancel===null?0:det.art.DescuentoArancel)
                    total_salvaguarda = total_salvaguarda + (det.salvaguarda===null || det.salvaguarda===""?0:det.salvaguarda)
                });

                this.setState({ data_importacion: this.props.detalle_importacion }, ()=>{
                    this.calcularSubtotal();
                    this.api.refreshCells();
                    let fobCalculado = this.sumarValorFob();
                    if(isNaN(fobCalculado)===true){
                        this.props.change('fob_r', 0)
                    }else{
                        this.props.change('fob_r', fobCalculado)
                    }
                    console.log('FOBARANCERL: ', this.props.FOBArancel)
                })
                //Modificacion del array detalle_forma pago                
                this.props.detalle_forma_pago.forEach((det_pago , i)=>{
                    
                    det_pago.secuencia = completar_String(i + 1,'0',3);
                    if(det_pago.tipo_fec === 1){
                        det_pago.descripcion = "FECHA CONFIRMACION";
                    }else{
                        det_pago.descripcion = "FECHA EMBARQUE";
                    }
                    det_pago.valorcalculado = det_pago.valorcalculado?parseFloat(det_pago.valorcalculado):0;
                    det_pago.valorAbono = this.calculoAbonoImport(det_pago.detAbonos);
                    det_pago.saldo = Math.round((det_pago.valorcalculado - det_pago.valorAbono)*100)/100;           
                    det_pago.modificar = det_pago.saldo === 0?false:true;
                    det_pago.poseePagos= det_pago.valorAbono>0?true:false
                })

                this.setState({ data_modal_forma_pg: this.props.detalle_forma_pago });  //()=>{console.log('FORMA pAGO: ', this.state.data_modal_forma_pg)})
                                      
                this.actualizarCabeceraGrid();
                this.setState({ codigo_importacion: codigo_import_editar})

                //this.props.change('fob_r', this.props.FOBArancel!==null?this.props.FOBArancel.toFixed(2):0)
                this.props.change('cif_r', this.props.CIF!==null?this.props.CIF.toFixed(2):0)

                //DATA Original a evaluar
                this.setState({
                    valorFobOriginal: parseFloat(this.props.FOBArancel),
                    fechaConfimacionOrg: this.props.fec_confirmacion, 
                    fechaEmbarqueOrg: this.props.fec_embarque 
                })

                //var totalcosto = 0;
                // totalcosto = (this.props.TotalCosto===null || this.props.TotalCosto===""?0:this.props.TotalCosto)+
                // (this.props.TotalCosto5===null || this.props.TotalCosto5===""?0:this.props.TotalCosto5)+
                // (this.props.TotalCosto10===null || this.props.TotalCosto10===""?0:this.props.TotalCosto10)+
                // (this.props.TotalCosto15===null || this.props.TotalCosto15===""?0:this.props.TotalCosto15)+
                // (this.props.TotalCosto20===null || this.props.TotalCosto20===""?0:this.props.TotalCosto20)+
                // (this.props.TotalCosto25===null || this.props.TotalCosto25===""?0:this.props.TotalCosto25)+
                // (this.props.TotalCosto30===null || this.props.TotalCosto30===""?0:this.props.TotalCosto30)

                this.props.change('total_costo_r', this.props.TotalCosto?this.props.TotalCosto.toFixed(2):0)
                this.props.change('salvaguarda_r', total_salvaguarda.toFixed(2))
                var CIF = this.props.CIF!==null?this.props.CIF:0;
                this.props.change('cif_salvaguarda_r', (CIF+total_salvaguarda).toFixed(2))

                var total = this.props.FOBArancel!==null?this.props.FOBArancel.toFixed(2):0
                this.setState({totalFOB: total})
            });   
        }         
    }

    calculoAbonoImport(array){
        let acc = 0;
        if(array.length > 0){
            array.forEach((ABO)=>{
                //acc += parseFloat(ABO.Valor)
                if(ABO.TipoCompteAjuste === 'ND') 
                {acc -= parseFloat(ABO.Valor)  //mbaquero 20240124 adiciona filtro TipoCompteAJuste
                }else 
                {acc += parseFloat(ABO.Valor)
                }
            })    
        }
        
        return Math.round(acc*100)/100;
    }

    addArticulo(){
        if (this.state.codigo_importacion === ''){
            alert('Ud. no ha seleccionado la importación a editar.');
        }else if (this.props.articulo_seleccionado === undefined){
            alert('Ud. no ha seleccionado el artículo que desea añadir.');
        }else if (this.props.cantidad_pedido === undefined){    
            alert('Ud. no ha indicado la cantidad del artículo que desea añadir.');      
        }else if (!this.props.precio_f){    
            alert('Ud. no ha indicado el precio del artículo que desea añadir.');
        // }else if(this.props.factura !== undefined){
        //     this.props.change('articulo_selector', null)
        //     this.props.change('cant_pedido', '');
        //     this.props.change('precio_fob', '');
        //     alert('La importacion tiene asignada la factura '+this.props.factura+' imposible añadir items.');
        }else{
            const articulo = this.props.articulo_seleccionado;
            let result = this.validacionItemsRepetidos(articulo.value)
            console.log('RESULT: ', result);

            if(result===true){
                let msg = window.confirm(`El artículo: ${articulo.value} ya se encuentra en la importación, ¿añadirlo?` )
                if(msg){
                    this.insertArticulo();
                }
            }else{
                this.insertArticulo(); 
            }             
        }   
    }

    insertArticulo(){
        const articulo = this.props.articulo_seleccionado;
        const cantidad = this.props.cantidad_pedido;
        const precio   = this.props.precio_f;
        const factura = this.props.factura;

        this.cargarObjetos('/articulos/'+articulo.value).then((result_arancel)=>{
            var impuesto = 0;
            if(result_arancel.impArancel!==null){
                impuesto = result_arancel.impArancel.Impuesto
            }

            let index_final = this.state.data_importacion.length - 1;
            let nro_item = 0;

            if(index_final===-1){
                nro_item = 1;
            }else{
                nro_item = parseInt(this.state.data_importacion[index_final].secuencial, 10)+1;
            }
            
            let item_articulo = {};

            this.setState({ arancel_temp:  impuesto},()=>{
                item_articulo.secuencial= completar_String(nro_item.toString(), '0', 3);
                item_articulo.articulo=articulo.value;
                item_articulo.nombre=formatearLabel(articulo.label);
                item_articulo.cantidad = cantidad;      
                item_articulo.precio_fob = Math.round(parseFloat(precio,10)*100)/100;
                item_articulo.recibido = factura?cantidad:0;
                item_articulo.arancel = this.state.arancel_temp;
                item_articulo.costo_cif = Math.round(precio*100)/100 * parseInt(item_articulo.cantidad,10);
                item_articulo.flete = 0;
                item_articulo.factor = 0;
                item_articulo.subtotal = Math.round((cantidad * item_articulo.precio_fob)*100)/100;
                
                this.setState({ data_importacion: this.immutablePush(this.state.data_importacion, item_articulo) },
                ()=>{
                    //alert('Item añadido: \nSec: '+item_articulo.secuencial+' item añadido: '+item_articulo.articulo+', '+item_articulo.nombre+' P FOB: '+item_articulo.precio_fob)
                    //Limpia control de adicion
                    this.props.change('articulo_selector', null)
                    this.props.change('cant_pedido', '');
                    this.props.change('precio_fob', '');
                    let newFob = this.sumarValorFob();
                    this.props.change('fob_r', newFob);
                    this.props.change('FOBArancel', newFob);
                })
            })
        })
        .catch((err)=>{
            alert('Error al agregar. ', err)
        });
    }

    validacionItemsRepetidos(codArticulo){
        let repetido = false;
        this.state.data_importacion.forEach((DATA)=>{
            if(DATA.articulo===codArticulo){
                repetido = true
            }
        })

        return repetido;
    }

    sumaFecha(d, fecha){
        var Fecha = new Date();
        var sFecha = fecha || (Fecha.getDate() + "/" + (Fecha.getMonth() +1) + "/" + Fecha.getFullYear());
        var sep = sFecha.indexOf('/') !== -1 ? '/' : '-'; 
        var aFecha = sFecha.split(sep);
        // eslint-disable-next-line
        var fecha = aFecha[2]+'/'+aFecha[1]+'/'+aFecha[0];
        
        fecha= new Date(fecha);

        fecha.setDate(fecha.getDate()+parseInt(d,10));
        var anno=fecha.getFullYear();
        var mes= fecha.getMonth()+1;
        var dia= fecha.getDate();
        mes = (mes < 10) ? ("0" + mes) : mes;
        dia = (dia < 10) ? ("0" + dia) : dia;
        var fechaFinal = dia+sep+mes+sep+anno;
        return (fechaFinal);
    }

    addFormaPago(){
        var acc=0;
        acc = (this.control_porcentaje_pago(this.state.data_modal_forma_pg));
        
        var porcentaje_pg = 0;
        porcentaje_pg = parseInt(this.props.porcentaje,10)

        var totalProcentajeIngreso = acc+porcentaje_pg
        if(acc>=100){
            alert("El porcentaje de pago ya cumple el 100%");
        }else if (this.props.tipo_fecha === undefined || parseInt(this.props.tipo_fecha, 10)>=3){
            alert('Ud. no ha seleccionado el tipo de fecha a añadir o esta fuera del rango.');
        }else if (this.props.cant_dias === undefined || parseInt(this.props.cant_dias, 10)<0){    
            alert('Ud. no ha indicado la cantidad de dias referente al pago.');      
        }else if (this.props.porcentaje === undefined || totalProcentajeIngreso>100){ 
            alert('Ud. no ha indicado el porcentaje de pago o este excede el 100%.');
        }else{
            
            this.cargarObjetos('/pagosimportacion?importacion='+this.state.codigo_importacion+'&opcion=saldo')
            .then((abonos)=>{
                console.log('ABONOS: ', abonos)
                var item_pago = {};
                item_pago.tipo_fec= parseInt(this.props.tipo_fecha, 10)
                console.log('TAMAÑO: ', this.state.data_modal_forma_pg.length)
                let index_final = this.state.data_modal_forma_pg.length - 1;
                let nro_item = 0;

                if(index_final===-1){
                    nro_item = 1
                }else{
                    nro_item = parseInt(this.state.data_modal_forma_pg[index_final].secuencia, 10)+1;
                }
                item_pago.secuencia= completar_String(nro_item, '0', 3);

                if(parseInt(this.props.tipo_fecha, 10)===1){
                    item_pago.descripcion= "FECHA CONFIRMACIÓN"
                    item_pago.fecha = desformatearFecha(this.props.fec_confirmacion);
                    
                    var fechaSumada;
                    fechaSumada = this.sumaFecha(parseInt(this.props.cant_dias, 10),this.props.fec_confirmacion)
                    item_pago.fecha_pago = desformatearFecha(fechaSumada)
                }else if(parseInt(this.props.tipo_fecha, 10)===2){
                    item_pago.descripcion= "FECHA EMBARQUE"
                    item_pago.fecha =  desformatearFecha(this.props.fec_embarque);
                
                    let fechaSumada;
                    fechaSumada =  this.sumaFecha(parseInt(this.props.cant_dias, 10),this.props.fec_embarque)
                    item_pago.fecha_pago = desformatearFecha(fechaSumada);
                }
                item_pago.dias_plazo = this.props.cant_dias;
                item_pago.porcentaje = parseInt(this.props.porcentaje,10);
                item_pago.estado = 'A'
                
                var total = this.props.fob_r;

                let resp = (total*parseInt(item_pago.porcentaje, 10))/100;
                item_pago.valorcalculado = Math.round(parseFloat(resp,10)*100)/100;
                item_pago.fob_base = total;

                item_pago.valorAbono = this.getAbonoInsert(abonos, item_pago.tipo_fec);
                console.log('VALOR ABONO: ',item_pago.valorAbono , 'VALOR CALCuLADO: ', item_pago.valorcalculado, 'SALDO: ', Math.round((parseFloat(item_pago.valorcalculado) - item_pago.valorAbono)*100)/100)
                item_pago.saldo = Math.round((parseFloat(item_pago.valorcalculado) - item_pago.valorAbono)*100)/100;
                
                item_pago.modificar = item_pago.saldo=== 0?false:true;

                if(item_pago.saldo > 0){
                    this.setState({ data_modal_forma_pg: this.immutablePush(this.state.data_modal_forma_pg, item_pago),modFormaPago: 1 })
                }else{
                    alert(`- Existe un abono de ${item_pago.valorAbono} en la ${item_pago.descripcion}, aumente el porcentaje de pago para continuar...`) 
                }
            })
            .catch((error)=>{
                alert(error)
            })
        }
    }

    getAbonoInsert(array, formaPago){   //mbaquero 20240126 anade filtro TipoCompteAjuste para suma de abonos
        let abono = 0;
        
        if(array.length > 0){
            array.forEach((ABO)=>{
                
                if(parseInt(ABO.CodTipoFecha, 10) === parseInt(formaPago, 10)){
                    if(ABO.Abono >= 0){
                        if(ABO.TipoCompteAjuste === 'ND') 
                            {abono -= parseFloat(ABO.Abono,10)  
                        }else 
                            {abono += parseFloat(ABO.Abono,10)
                        }
                    }
                }
            })
        }

        return Math.round(abono*100)/100;
    }

    actualizarMetodosPago(){
        if(this.props.estado_import !=='C'){
            console.log('ENTRO A mODIFICAR!!!!!!!!!!!')
            let planPagoImportacion = this.state.data_modal_forma_pg
            let fecha = null;
            //let reCalcularFob = null;
            let totalAbonado=0;

            if(planPagoImportacion.length > 0){
                //Condicional, se procedera a recorrer el planPagoImportacion para verificar si tiene pago realizados, en caso de tenerlos el usuario debera ingresar el valor a pgar 
                planPagoImportacion.forEach((pago)=>{
                    if(pago.detAbonos.length>0){    //si cualquier pago posee abonos se acumulura.
                        for(let i=0; i< pago.detAbonos.length; i++){    //mbaquero 20240202 anade TipoCompteAjuste
                        if (pago.detAbonos[i].TipoCompteAjuste === "ND") 
                            {totalAbonado=totalAbonado- pago.detAbonos[i].Valor}
                        else {totalAbonado=totalAbonado+ pago.detAbonos[i].Valor}                          
                        }
                    }
                })
                if(totalAbonado===0){// Es el total de abono de todo el plan de importacion. Si NO POSEE PAGOS SE PROCEDERA A RECALCULAR EN BASE AL NUEVO F.O.B.
                    //proceso de recalculo
                    planPagoImportacion.forEach((PAG)=>{
                        if(parseInt(PAG.tipo_fec,10) === 1){
                            fecha = this.props.fec_confirmacion;
                        }else if(parseInt(PAG.tipo_fec,10) === 2){
                            fecha = this.props.fec_embarque;
                        }

                        PAG.fecha = desformatearFecha(fecha);
                        let fechaSumada = moment(fecha, 'DD/MM/YYYY').add(parseInt(PAG.dias_plazo, 10), 'days');
                        PAG.fecha_pago = desformatearFecha(formatearFechaMoment_a_String(fechaSumada));
                        let valorFob = Math.round(parseFloat(this.props.fob_r)*100)/100;
                        let resp = (valorFob*parseInt(PAG.porcentaje, 10))/100;
                        PAG.valorcalculado = Math.round(parseFloat(resp,10)*100)/100;
                        PAG.fob_base = valorFob;
                        PAG.saldo=  Math.round(parseFloat(resp,10)*100)/100;
                        this.setState({esEditable:true})
                    })
                }else{
                    if(planPagoImportacion.length===2)
                    {   //el pago esta dividido en 2
                        //se verifica que el primero tenga saldo 0, si esta con saldo cero se procedera a recuperar el valor a pgar y restarlo del nuevo F.O.B
                        let totalAbono=0;
                        let totalAbono1=0;
                        let resultado=0;
                        for(let i=0; i < planPagoImportacion[0].detAbonos.length; i++){
                            if (planPagoImportacion[0].detAbonos[i].TipoCompteAjuste === "ND")
                            {totalAbono=totalAbono- planPagoImportacion[0].detAbonos[i].Valor}
                            else{totalAbono=totalAbono+ planPagoImportacion[0].detAbonos[i].Valor}
                        }
                        resultado= planPagoImportacion[0].valorcalculado - totalAbono
                        if(resultado===0){//Se procede a calcular el valor para el segundo pago
                            if(parseInt(planPagoImportacion[1].tipo_fec,10) === 1){
                                fecha = this.props.fec_confirmacion;
                            }else if(parseInt(planPagoImportacion[1].tipo_fec,10) === 2){
                                fecha = this.props.fec_embarque;
                            }
                            planPagoImportacion[1].fecha = desformatearFecha(fecha);
                            let fechaSumada = moment(fecha, 'DD/MM/YYYY').add(parseInt(planPagoImportacion[1].dias_plazo, 10), 'days');
                            planPagoImportacion[1].fecha_pago = desformatearFecha(formatearFechaMoment_a_String(fechaSumada));
                            let valorFob = Math.round(parseFloat(this.props.fob_r)*100)/100;
                            let total= valorFob - planPagoImportacion[0].valorcalculado;
                            planPagoImportacion[1].valorcalculado = Math.round(parseFloat(total,10)*100)/100;
                            planPagoImportacion[1].fob_base = valorFob;
                            //mbaquero 20240202 anade suma de abonos
                            for(let i=0; i < planPagoImportacion[1].detAbonos.length; i++){
                            if (planPagoImportacion[1].detAbonos[i].TipoCompteAjuste === "ND")
                            {totalAbono1=totalAbono1- planPagoImportacion[1].detAbonos[i].Valor}
                            else{totalAbono1=totalAbono1+ planPagoImportacion[1].detAbonos[i].Valor}
                            }
                            planPagoImportacion[1].saldo=  Math.round(parseFloat((total-totalAbono1),10)*100)/100;
                        }else{
                            let columsDefs_modal= this.state.columnDefs_modal;
                            columsDefs_modal[8].editable=true;
                            this.setState({columsDefs_modal})
                            if(!this.state.isOpen)
                            alert("Por favor modifique el valor a pagar")
                        }

                    }else{
                        let columsDefs_modal= this.state.columnDefs_modal;
                        columsDefs_modal[8].editable=true;
                        this.setState({columsDefs_modal})
                        if(!this.state.isOpen)
                        alert("Por favor modifique el valor a pagar.")
                    }
                   
                }
                
                // planPagoImportacion.forEach((PAG)=>{

                //     if(PAG.modificar === true){

                //         if(parseInt(PAG.tipo_fec,10) === 1){
                //             fecha = this.props.fec_confirmacion;
                //         }else if(parseInt(PAG.tipo_fec,10) === 2){
                //             fecha = this.props.fec_embarque;
                //         }

                //         PAG.fecha = desformatearFecha(fecha);
                //         let fechaSumada = moment(fecha, 'DD/MM/YYYY').add(parseInt(PAG.dias_plazo, 10), 'days');
                //         console.log(PAG)
                //         //FUNC PARA DETERMINAR SI ACTUALIZA O NO LA FORMA DE PAGO
                //         if(parseInt(PAG.tipo_fec,10) === 1 ){
                //             reCalcularFob = Math.round(parseFloat(PAG.valorcalculado, 10)*100)/100
                //             console.log("EN RECALCULO 1")
                //             console.log(reCalcularFob)
                //             //return;
                //         }else{
                //             PAG.fecha_pago = desformatearFecha(formatearFechaMoment_a_String(fechaSumada));
                //             PAG.fob_base = parseFloat(this.props.fob_r, 10).toFixed(2);
                //             //Recalcula en base a FP1
                //             console.log('RECALCULO: ', PAG.modificar)

                //             let valorFob = Math.round(parseFloat(this.props.fob_r)*100)/100;
                //             PAG.valorcalculado =  valorFob - reCalcularFob;
                //            
                //         }
                //     }else{
                //         //Calcula normalmente en base a ValorFob
                //         // console.log('--ESLE RECALCULO: ', PAG.modificar)
                //         // console.log('FOB BASE: ', PAG.fob_base, ' PORCENtAJE: ', PAG.porcentaje)
                //         // PAG.valorcalculado = (PAG.fob_base * (parseInt(PAG.porcentaje,10)/100));
                //         // console.log('VAL: ', PAG.valorcalculado)
                //     }    
                // })
                this.api.refreshCells();
            }
        }
    }

    //OK
    controlCambiosFechasImportacion(){
        let permitirCambios = false;

        let fechaConfOriginal = moment(this.state.fechaConfimacionOrg, 'DD/MM/YYYY');
        let fechaEmbarqueOrignal = moment(this.state.fechaEmbarqueOrg, 'DD/MM/YYYY');
        
        let fechaConfirmacion = moment(this.props.fec_confirmacion,'DD/MM/YYYY');
        let fechaEmbarque = moment(this.props.fec_embarque,'DD/MM/YYYY');

        let valorFobOriginal = Math.round(parseFloat(this.state.valorFobOriginal)*100)/100;
                
        if(fechaConfOriginal.isSame(fechaConfirmacion) && fechaEmbarqueOrignal.isSame(fechaEmbarque)){
            permitirCambios = false;
        }else{
            permitirCambios = true;
        }

        console.log('VALOR FOB ORIGINAL: ', valorFobOriginal, 'TOTALFOBcAL: ', this.sumarValorFob(), 'COMP: ',valorFobOriginal !== this.sumarValorFob())
        if(valorFobOriginal !== this.sumarValorFob() && valorFobOriginal > 0){
            permitirCambios = true;
        }

        return permitirCambios;
    }

    sumarValorFob(){
        let sumValor = 0;
        this.state.data_importacion.forEach((DATA)=>{
            sumValor += parseFloat(DATA.subtotal)
        })

        return Math.round(sumValor*100)/100;
    }
    
    //Retorna el porcentaje de pago actual en el array
    control_porcentaje_pago(arr){
        
        var acc=0;
        arr.forEach((data)=>{
            acc = acc + parseInt(data.porcentaje,10);
        })
        return acc;
    }
    control_valor_pagar(arr){//retorna el valor a pagar acumulado de todas las formas de pago
        var acc=0;
        arr.forEach((data)=>{
            acc = acc + parseFloat(parseFloat(data.valorcalculado).toFixed(2));
        })
        return acc;
    }
    
    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }
    
    methodFromParent(id, datos_fila) {
        var mensaje;
        if(datos_fila.articulo!=="" && datos_fila.tipo_fec===undefined){
            mensaje = window.confirm("¿Desea eliminar el registro?"); 
            if (mensaje){
                this.eliminar(datos_fila ,id ) 
            }
        }else if(datos_fila.tipo_fec>0 && datos_fila.articulo===undefined){
            if(this.props.compra===""|| this.props.compra===null){
                
                if(datos_fila.modificar === true){
                    mensaje = window.confirm("¿Desea eliminar la forma de pago?"); 
                    if (mensaje){
                        this.eliminarFormaPago(datos_fila ,id ) 
                    }
                }else{
                    alert("Ya existen pagos, no se puede modificar la forma de pago actual")
                }                
            }else{
                alert("No se puede modificar las formas de pago cuando tiene compra asignada")
            }
        } 
    }


    eliminarFormaPago(datos_fila ,id){        
        this.setState(
            {data_modal_forma_pg: this.immutableDelete(this.state.data_modal_forma_pg, id),
            modFormaPago: 1}
        )
    }
     
    //Calculo para renderCalculable id datos_fila
    calcularColSubtotal(dataFila){ 
        
        if(dataFila.cantidad > 0 && (this.props.factura==="" || this.props.factura===undefined)){
            dataFila.subtotal = dataFila.precio_fob * dataFila.cantidad
        }else{
            if(dataFila.recibido >= 0 && this.props.factura!==""){
                dataFila.subtotal = dataFila.precio_fob * dataFila.recibido
            }
        }
    }

    calcularSubtotal(){ 
        this.state.data_importacion.forEach((DET)=>{
            if(DET.cantidad > 0 && (this.props.factura==="" || this.props.factura===undefined)){
                DET.subtotal = DET.precio_fob * DET.cantidad
            }else{
                if(DET.recibido >= 0 && this.props.factura!==""){
                    DET.subtotal = DET.precio_fob * DET.recibido
                }
            }
        })
    }

    eliminar(datos_fila, id ){
        var e = {};
        e.localidad = '01';
        e.secuencia = datos_fila.secuencial;
        this.setState({ data_importacion: this.immutableDelete(this.state.data_importacion, id)}
        ,()=>{
            let newFob = this.sumarValorFob();
            this.props.change('fob_r', newFob);
            this.props.change('FOBArancel', newFob);
        })
    }
    
    immutableDelete (arr, index) {        
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }

    getOptions_Articulos(input, callback){
        if (input.toString().length >= 2 ){
            let query = "?tipo=catalogo&cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/articulos', query, callback)
        }
    }

    inicializarComponentes(){
        this.props.cargar_ValoresIniciales();
        let columnDefs_modal= this.state.columnDefs_modal;
        columnDefs_modal[8].editable=false;
        this.setState({operacion: 'G', data_importacion: [], 
        codigo_importacion: '', modFormaPago: null, 
        columnDefs_modal,
        //revisarMetodosPago: false,
        valorFobOriginal: 0,
        fechaConfimacionOrg: null,
        fechaEmbarqueOrg: null});
        console.log(this.state)
    }

    corregirCantidad(e){        
        if(parseInt(this.props.cantidad_pedido,10) < 0 ){        
            const valor = 0;
            this.props.change('cant_pedido', valor)
        }
    }

    imprimir(){
        if(this.state.opcionesPrint === 'P'){
            visualizarReporteEnPdf('&rpt=5&param1='+this.state.codigo_importacion)
        }else if(this.state.opcionesPrint === 'E'){
            generarReporteEnExcel('&rpt=82&param1='+this.state.codigo_importacion)
        }
    }
    
    //Presenta la Importacion hecha compra
    impCompraImp(){
        visualizarReporteEnPdf('&rpt=6&param1='+this.state.codigo_importacion)
    }

    //Presenta los gasto de la importacion
    impLiqImportacion(){

        
        if(this.state.codigo_importacion!==''){
            if  (this.state.cantidadArancel<9) {
            visualizarReporteEnPdf('&rpt=7&param1='+this.state.codigo_importacion)
            }
            else{
                visualizarReporteEnPdf('&rpt=148&param1='+this.state.codigo_importacion)
            }

        }else{
            alert("Cargue una importación antes de continuar");
        }        
    }

    //Presenta los gasto de la importacion
    impLiqImportacionB(){
        if(this.state.codigo_importacion!==''){
            visualizarReporteEnPdf('&rpt=147&param1='+this.state.codigo_importacion)
        }else{
            alert("Cargue una importación antes de continuar");
        }        
    }

    //Anulacion de Importacion
    anularImportacion(){
        var errors = "";
        var proceder = true;

        //Validación de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        var ValorAbonoImp =0
      
    
        this.props.detalle_forma_pago.forEach((det_pago , i)=>{
            ValorAbonoImp =ValorAbonoImp + det_pago.valorAbono;
        })

        //RTOALA 2021-10-29
        if (ValorAbonoImp >0){
            proceder = false
                alert("La Importacion tiene pagos, imposible anular")
            }


        if(proceder === true){
            this.props.cambiar_VisualizacionLoading(true);
            global_axios({
                url: '/importaciones/'+this.state.codigo_importacion,
                method: 'DELETE',
                headers: {'idregaudit': this.props.IdRegAudit}
              })
              .then((response)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(response.data.msg);
                this.inicializarComponentes();
              })
              .catch((error)=>{                
                this.props.cambiar_VisualizacionLoading(false);
                alert(error.response?error.response.data.msg:error.message);
            });
        }else{
            alert(errors);
        }
    }

    //Funcion Actualizar Arancel
    updArancel(){
        if(this.state.codigo_importacion!==''){
            var data = {};

            data.importacion = this.state.codigo_importacion;
            let msg = window.confirm('Esta a punto de actualizar el arancel de la importacion, ¿Continuar?');

            let config_request = {
                method: 'PATCH',
                url: `/importaciones/${this.state.codigo_importacion}/arancel`,
                data
            }

            if(msg){
                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then((response)=>{
                    console.log('respuesta: ', response)
                    if(response!==null){
                        alert(response.data.msg);

                        this.props.cambiar_VisualizacionLoading(false);
                        this.props.cargar_ValoresIniciales();   
                                
                        //Proceso de carga de importacion
                        let imp = {}
                        imp.value = this.state.codigo_importacion;
                        imp.label = this.state.codigo_importacion;
                        
                        this.props.change('importacion', imp)
                        this.getImportacion();
                    }                      
                })
                .catch((error)=>{   
                    this.props.cambiar_VisualizacionLoading(false);             
                    alert(error.response?error.response.data.msg:error.message);  
                });
            }
        }else{
            alert("Cargue una importación antes de continuar");
        }        
    }
    
    render(){
        
        const { handleSubmit, submitting } = this.props
        return(
            <ContenedorForm porc_ancho={80}>
            <HeaderForm>
                <TituloForm>Importaciones</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit margen_abajo='4'>
                        <Row>                         
                            <div className='col-md-6'>
                                <Field
                                    label="Importación:"
                                    name="importacion"
                                    component={ FieldBusqEspecifica }
                                    loadOptions={this.getOptions_Importaciones.bind(this)} 
                                    getItemEspecifico={()=>{this.getImportacion()}}                                   
                                    func_OnFocus={this.inicializarComponentes}
                                    textoBoton="Sel."
                                    icono="fa fa-check-circle-o"/>
                            </div>
                            <ContainerCol className='col-sm-2 col-sm-offset-4'>
                                <LabelForm>Fecha Proceso:</LabelForm>
                                <PickerFecha fechaSeleccionada={this.state.fechaProceso} disabled={this.props.permiteCambioFProceso==='S'?false:true} func_onChange={(fechaEscogida)=>{this.setState({fechaProceso: fechaEscogida})}}/>
                            </ContainerCol>
                        </Row>                        
                    </ContainerEdit>
                        <form onSubmit={handleSubmit(this.submit.bind(this))}>
                            <Row>
                                <div className='col-md-2'>
                                    <Field
                                        name="codigo"
                                        readonly={true}
                                        component={ FieldGenerico }
                                        label="N. Importacion:"/>                                                                    
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="dai_num"
                                        component={ FieldGenerico }
                                        mayusculas={true}
                                        label="D.A.I N°:"/>                                                                    
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="poliza"
                                        component={ FieldGenerico }
                                        mayusculas={true}
                                        label="Poliza N°:"/>                                
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="forma_pago"
                                        component={ FieldSelect }
                                        label="Forma de pago:"
                                        options={this.state.forma_pago}/>                                
                                </div>
                                <div className='col-md-4'>
                                    <Field
                                        name="proveedor"
                                        component={ FieldSelect }
                                        disabled={true}
                                        label="Proveedor:"
                                        options={this.state.proveedor}/>                                
                                </div>                                
                            </Row>  
                            <Row>
                                <div className='col-md-2'>
                                    <Field
                                        name="fec_contable"
                                        readOnly={true}
                                        component={ FieldDate }
                                        label="Fecha Contable:"
                                        placeholder="dd/mm/aaaa"/>
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="lote_import"
                                        component={ FieldGenerico }
                                        label="Lote de importación:"/>                                
                                </div>                                                                                                
                                <div className='col-md-2'>
                                    <Field
                                        name="fec_confirmacion"
                                        component={ FieldDate }
                                        label="Confirmación:"
                                        placeholder="dd/mm/aaaa"
                                        //onBlur={this.activadorVerificadorFechaPorPago}
                                        readOnly={this.props.factura?true:false}
                                        />
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="fec_embarque"
                                        component={ FieldDate }
                                        label="Embarque Origen:"
                                        placeholder="dd/mm/aaaa"
                                        readOnly={this.props.factura?true:false}
                                        //onBlur={this.activadorVerificadorFechaPorPago}
                                        />
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="fec_llegada_aduana"
                                        component={ FieldDate }
                                        label="Llegada Aduana:"
                                        placeholder="dd/mm/aaaa"/>
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="fec_recepcion_ofi"
                                        component={ FieldDate }
                                        label="Recepción Oficina:"
                                        placeholder="dd/mm/aaaa"/>
                                </div>                                                         
                            </Row>
                            <Row>
                                <div className='col-md-2'>
                                    <Field
                                        name="factura_p"
                                        component={ FieldGenerico }                                        
                                        label="Factura Pedido:"
                                        func_OnBlur={this.verificacionActualizarCabeceras.bind(this)}
                                        readonly={this.props.lote_import===undefined?true:this.props.lote_import!==""?false:true}
                                        />                                
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="compra"
                                        readonly={true}
                                        component={ FieldGenerico }
                                        label="Compra:"/>                                 
                                </div>
                                <div className='col-md-4'>
                                    <Field
                                        name="articulo_selector"
                                        component= { FieldGetSelectAsync }
                                        label="Artículo:"
                                        loadOptions={ this.getOptions_Articulos.bind(this) }
                                        setFieldToBeFocused={input => {this.input = input;}}/>
                                </div>                                
                                <div className='col-md-1'>
                                    <Field
                                        name="cant_pedido"
                                        type="number"
                                        component={ FieldGenerico }
                                        onBlur={this.corregirCantidad.bind(this)}
                                        label="Cantidad:"/>                                
                                </div>
                                <div className='col-md-2'>
                                    <div style={{width: '140px'}} className='input-group'>
                                        <Field
                                            name="precio_fob"
                                            type="number"
                                            component={ FieldGenerico }
                                            label="P. FOB:"
                                            />   
                                        <span className='input-group-btn'>
                                            <BotonAdd type="button" className='btn btn-success btn-sm' onClick={this.addArticulo.bind(this)}><i className="fa fa-plus"></i></BotonAdd>
                                        </span>
                                    </div>                             
                                </div>
                                <ContainerCol className='col-sm-1' margen_arriba='-5'>
                                    <LabelForm>Arancel:</LabelForm>
                                    <BotonAdd type="button" className='btn btn-primary btn-sm' onClick={this.updArancel.bind(this)}><i className="fa fa-refresh"></i> Act.</BotonAdd>
                                </ContainerCol>                                                            
                            </Row>
                            <Row>
                                <div className='col-md-12'>
                                    <AgGridRender altura='200px' data={this.state.data_importacion} columnas={this.state.columnDefs} gridOptions={this.state.gridOptions} onGridReady={this.onGridReady}/>                                                           
                                </div>
                            </Row>
                            <Row>                         
                                <div className='col-md-2'>
                                    <Field
                                        name="fob_r"
                                        type="number"
                                        readonly={true}
                                        component={ FieldGenerico }
                                        label="F.O.B.:"/>                                
                                </div>                                
                                <div className='col-md-2'>
                                    <Field
                                        name="cif_r"
                                        type="number"
                                        readonly={true}
                                        component={ FieldGenerico }
                                        label="C.I.F.:"/>                                
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="salvaguarda_r"
                                        type="number"
                                        readonly={true}
                                        component={ FieldGenerico }
                                        label="Salvaguarda:"/>                                
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="cif_salvaguarda_r"
                                        type="number"
                                        readonly={true}
                                        component={ FieldGenerico }
                                        label="C.I.F.+Salvaguarda:"/>                                
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="total_costo_r"
                                        type="number"
                                        readonly={true}
                                        component={ FieldGenerico }
                                        label="Total Costo:"/>                                
                                </div>          
                            </Row>                               
                            <Row>                               
                                <div className='col-md-12'>                                    
                                    <div className="btn-group pull-right">                                    
                                        <button type="submit" className='btn btn-primary btn-sm' disabled={submitting}>
                                            <i className="fa fa-floppy-o fa-lg"></i> Guardar
                                        </button>
                                        <button type="button" className='btn btn-sm' onClick={this.inicializarComponentes}>
                                            <i className="fa fa-trash-o fa-lg"></i> Limpiar
                                        </button>
                                        <button type='button' className='btn btn-danger btn-sm' disabled={this.props.compra==='' || this.props.compra===null?false:true} onClick={this.anularImportacion}>
                                            <i className='fa fa-window-close  fa-lg'/> Anular
                                        </button>
                                        
                                        <button type="button" className='btn btn-info btn-sm' disabled={(this.state.codigo_importacion==="")?true:false} onClick={this.toggleModal}>
                                            <i className="fa fa-credit-card-alt"></i> Forma de pago
                                        </button>

                                        <button type="button" className='btn btn-sm' disabled={(this.props.factura && this.props.lote_import && this.props.factura && this.state.data_importacion.length > 0)?false:true} onClick={this.toggleModalCompra}>
                                            <i className="fa fa-refresh" aria-hidden="true"></i> Generar compra
                                        </button>

                                        <button type='button' style={this.state.liquidacionButton} className='btn btn-success btn-sm' disabled={this.state.codigo_importacion===''?true:false} onClick={this.impLiqImportacion}>
                                            <i className="fa fa-print fa-lg" aria-hidden="true"/> Liquidacíon 
                                        </button> 

                                         <button type='button' style={this.state.liquidacionButton} className='btn btn-success btn-sm' disabled={this.state.codigo_importacion===''?true:false} onClick={this.impLiqImportacionB}>
                                            <i className="fa fa-print fa-lg" aria-hidden="true"/> Liquidacíon B
                                        </button> 

                                        <button type='button' className='btn btn-default btn-sm' disabled={this.state.codigo_importacion===''?true:false} onClick={this.toggleModalDetImp}>
                                            <i className="fa fa-print fa-lg" aria-hidden="true"/> Det. Importación
                                        </button>

                                        <button type='button' className='btn btn-info btn-sm' disabled={this.state.codigo_importacion===''?true:this.props.estado_import!=='C'?true:false} onClick={this.impCompraImp}>
                                            <i className="fa fa-print fa-lg" aria-hidden="true"/> Reporte Comp.
                                        </button>                

                                    </div>                                                                        
                                </div>
                            </Row>                                 
                        </form>                                                
                </CuerpoForm>
                    
                {/*MODAL FORMA DE PAGO*/}
                <ModalResponsive open={this.state.isOpen} ocultarClose={false} onClose={()=>{this.setState({isOpen:false})}}>
                    <HeaderForm>
                        <TituloForm>Forma de pago</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <ContenedorModal>
                            <Row>
                                <div className='col-md-3'>
                                    <Field
                                        name="select_fecha"
                                        component={ FieldSelect }
                                        label="Tipo:"
                                        options={this.state.optFechasPago}
                                        onBlur={this.setFormaPago.bind(this)}/>
                                </div>
                                <div className='col-md-3'>                                        
                                    <Field
                                        name="fec_seleccionada"
                                        component={ FieldDate }
                                        label="Fecha:"  
                                        readOnly={true}                                  
                                        placeholder="dd/mm/aaaa"/>
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="cant_dias"
                                        type="number"
                                        component={ FieldGenerico }
                                        label="Dias:"/>                                
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="porcentaje_pg"
                                        type="number"
                                        component={ FieldGenerico }
                                        label="Porcentaje:"/>                                
                                </div>
                                <div className='col-md-2'>
                                    <ContenedorBotonAdd>
                                        <button type="button" disabled={this.props.compra===""|| this.props.compra===null?false:true} className='btn btn-success btn-sm' onClick={this.addFormaPago.bind(this)}><i className="fa fa-plus"></i> Añadir</button>
                                    </ContenedorBotonAdd>
                                </div>                                        
                            </Row>
                            <Row>
                                <div className='col-md-12'>
                                    <AgGridRender altura='140px' data={this.state.data_modal_forma_pg} columnas={this.state.columnDefs_modal} gridOptions={this.state.gridOptionsModal} onGridReady={this.onGridReadyPago} /*onGridReady={this.onGridReady}*//>                                                           
                                </div>
                            </Row>
                            <Row>
                                <div className='col-md-12'>
                                    <div className="btn-group pull-right">
                                        <button type="button" className='btn btn-primary btn-sm' disabled={this.props.compra===""|| this.props.compra===null?false:true} onClick={this.saveFormaPago.bind(this)}>
                                            <i className="fa fa-floppy-o fa-lg"></i> Guardar
                                        </button>
                                        <button type="button" className='btn btn-sm' onClick={this.toggleModal}>
                                            <i className="fa fa-times-circle"></i> Cerrar
                                        </button>                                                
                                    </div>                                     
                                </div>
                            </Row>                                             
                        </ContenedorModal>
                    </CuerpoForm>
                </ModalResponsive>

                {/*MODAL COMPRA*/}
                <ModalResponsive open={this.state.isOpenCompra} onClose={()=>{this.setState({isOpenCompra: false})}}>
                    <HeaderForm>
                        <TituloForm>Forma de pago</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <ContenedorModalCompra>
                        <Row>                            
                            <div className='col-md-5'>                                        
                                <Field
                                    name="bodega"
                                    component={ FieldSelect }
                                    label="Bodega:"
                                    options={this.state.bodega}/> 
                            </div>
                            <div className='col-md-7'>
                                <Field
                                    name="tipoCT"
                                    component={ FieldSelect }
                                    label="Tipo C.T:"
                                    options={this.state.tipoCT}/>                                 
                            </div>                                                            
                        </Row>                      
                        <Row>
                            <div className='col-md-12'>
                                <div className="btn-group pull-right">
                                    <button type="button" className='btn btn-primary btn-sm' disabled={((this.props.compra!=="")?true:false)}  onClick={this.saveCompra.bind(this)}>
                                        <i className="fa fa-floppy-o fa-lg"></i> Guardar
                                    </button>
                                    <button type="button" className='btn btn-sm' onClick={this.toggleModalCompra}>
                                        <i className="fa fa-times-circle"></i> Cerrar
                                    </button>
                                    <button type='button' className='btn btn-danger btn-sm' disabled={!(this.props.compra!==""?true:false)} onClick={this.anularCompra}><i className='fa fa-window-close  fa-lg'/> Anular</button>                                                
                                </div>                                     
                            </div>
                        </Row>  
                        </ContenedorModalCompra>
                    </CuerpoForm>
                </ModalResponsive>                          
            
                {/*MODAL IMP. DET. Importacion*/}
                <ModalResponsive open={this.state.isOpenDetImp} onClose={()=>{this.setState({isOpenDetImp: false})}}>
                    <HeaderForm>
                        <TituloForm>Detalle importación</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <ContenedorModalCompra>
                        <Row> 
                            <ContainerCol className='col-md-12'>
                                <LabelSub><Radio name="opcionesPrint" type='radio'  value='P' onChange={this.actualizarCamposCheque} checked={this.state.opcionesPrint==='P'?true:false}/>{' Imprimir en PDF  '}</LabelSub>
                                <LabelSub><Radio name="opcionesPrint" type='radio'  value='E' onChange={this.actualizarCamposCheque} checked={this.state.opcionesPrint==='E'?true:false}/>{" Imprimir en Excel"}</LabelSub>
                            </ContainerCol>                                               
                        </Row>                      
                        <Row>
                            <div className='col-md-12'>
                                <div className="btn-group pull-right">
                                    <button type="button" className='btn btn-primary btn-sm' onClick={this.imprimir.bind(this)}>
                                        <i className="fa fa-print fa-lg"></i> Imprimir
                                    </button>
                                    <button type="button" className='btn btn-sm' onClick={this.toggleModalDetImp}>
                                        <i className="fa fa-times-circle"></i> Cerrar
                                    </button>                                                                                 
                                </div>                                     
                            </div>
                        </Row>  
                        </ContenedorModalCompra>
                    </CuerpoForm>
                </ModalResponsive>
            </ContenedorForm>  
        )
    }
}

const selector = formValueSelector('form_impor02');

FormImport02 = reduxForm({
    form: 'form_impor02', enableReinitialize: true, validate
})(FormImport02)

FormImport02 = connect( 
    state => ({
        initialValues: state.inicializacion_form.data,
        isVisibleLoading: state.ui.isVisibleLoading,
        codigo_importacion: selector(state, 'importacion'),
        detalle_importacion: selector(state, 'detalle_import'),
        detalle_forma_pago: selector (state, 'plan_pago'),

        articulo_seleccionado: selector(state, 'articulo_selector'),
        cantidad_pedido: selector(state, 'cant_pedido'),
        precio_f: selector(state, 'precio_fob'),
        factura: selector(state, 'factura_p'),
        compra: selector(state, 'compra'),
        cantidadArancel: selector(state, 'CantidadAranceles'),

        estado_import: selector (state, 'estado_import'),
        cuenta: selector (state, 'cuenta'),

        tipo_fecha: selector(state, 'select_fecha'),
        cant_dias: selector(state, 'cant_dias'),
        porcentaje: selector(state, 'porcentaje_pg'),
        
        fec_confirmacion: selector(state, 'fec_confirmacion'),
        fec_embarque: selector(state, 'fec_embarque'),

        FormaPago: selector(state, 'forma_pago'),
        Proveedor: selector(state, 'proveedor'),
        DUI: selector(state, 'dai_num'),
        tipoCT: selector(state, 'tipoCT'),
        bodega: selector(state, 'bodega'),
        FOBArancel: selector(state, 'FOBArancel'),
        CIF: selector(state, 'CIF'),
        TotalCosto: selector(state, 'TotalCosto'),
        TotalCosto5: selector(state, 'TotalCosto5'),
        TotalCosto10:selector(state, 'TotalCosto10'),
        TotalCosto15:selector(state, 'TotalCosto15'),
        TotalCosto20:selector(state, 'TotalCosto20'),
        TotalCosto25:selector(state, 'TotalCosto25'),
        TotalCosto30:selector(state, 'TotalCosto30'),
        lote_import: selector(state, 'lote_import'),
        
        fob_r: selector(state,'fob_r'),
        
        IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit, 
        Usuario: state.sesion.valoresSesionForm.Usuario,
        permiso: state.sesion.valoresSesionForm.Permiso,
        permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
        diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias
    }),
    { cargar_Importacion_a_Editar: cargar_Importacion,
      cargar_ValoresIniciales,
      cambiar_VisualizacionLoading, generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm
    }
)(FormImport02)
export default FormImport02;